// src/features/whatsapp/pages/FeedbackAlertPage.tsx
// Re-cableado a lealify-base (Inc11): alerta al DUEÑO cuando un cliente deja opinión mala/neutral (evento feedback_alert).
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import EventMessageEditor from '../components/EventMessageEditor';

const FeedbackAlertPage: React.FC = () => (
  <EventMessageEditor
    eventKey="feedback_alert"
    title="Alerta de Opinión"
    subtitle="Recibe un WhatsApp cuando un cliente deja una opinión mala o neutral, para contactarlo a tiempo"
    icon={<AlertTriangle className="h-5 w-5 sm:h-6 sm:w-6 mr-2 text-amber-500" />}
    feature="Alerta de Opinión"
    defaultTemplate={'⚠️ @nombre dejó una opinión "@calificacion" en @negocio. Conviene contactarlo.'}
    variables={[
      { key: '@nombre', label: 'Nombre del cliente', example: 'María' },
      { key: '@negocio', label: 'Nombre de tu negocio', example: 'tu negocio', aliases: ['@marca'] },
      { key: '@calificacion', label: 'Opinión dejada', example: 'malo', aliases: ['@feedback'] },
      { key: '@sucursal', label: 'Sucursal de la visita', example: 'Centro' },
    ]}
    extraField={{
      settingKey: 'alert_phone',
      kind: 'phone',
      label: 'WhatsApp donde recibir la alerta',
      placeholder: '52 686 123 4567',
      help: 'Número (con clave de país) que recibirá el aviso. Suele ser el tuyo o el de tu encargado.',
    }}
    allowImage
    enabledHint={{ on: 'Recibirás un aviso por cada opinión mala o neutral', off: 'Activar para recibir alertas de opiniones negativas' }}
    stepGuide={{
      description: 'Cuando un cliente califica su experiencia como mala o neutral, el sistema te avisa por WhatsApp al número configurado para que puedas contactarlo.',
      steps: ['Cliente deja opinión', 'Sistema detecta mala/neutral', 'WhatsApp al dueño'],
    }}
    requirementsReady="Todo listo — recibirás un aviso ante cada opinión negativa"
  />
);

export default FeedbackAlertPage;
